export interface Movie {
  id: string;
  title: string;
  category: "movie" | "tv" | "variety" | "anime";
  genres: string[];
  region: string;
  year: number;
  rating: number;
  director: string;
  actors: string[];
  synopsis: string;
  duration: string;
  quality: string;
  cover: string;
  banner?: string;
  featured?: boolean;
  updatedAt: string;
}

export const categories = [
  {
    key: "movie",
    name: "电影",
    icon: "ri-movie-2-line",
    desc: "院线大片、类型佳作与高分口碑电影，高清画质一网打尽。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20dark%20theater%20hall%20with%20glowing%20screen%20and%20red%20seats%2C%20dramatic%20projector%20light%20beam%2C%20deep%20blue%20and%20orange%20tones%2C%20film%20aesthetic%20high%20detail&width=600&height=400&seq=sehu-cat-movie&orientation=landscape",
  },
  {
    key: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    desc: "热播剧集、经典长篇与口碑神作，追剧不停歇。",
    image: "https://readdy.ai/api/search-image?query=dramatic%20tv%20series%20scene%20with%20vintage%20television%20and%20warm%20living%20room%20light%2C%20deep%20blue%20shadows%20with%20orange%20accent%2C%20cozy%20cinematic%20mood%2C%20high%20detail&width=600&height=400&seq=sehu-cat-tv&orientation=landscape",
  },
  {
    key: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    desc: "音乐、综艺、真人秀与竞技节目，轻松娱乐全都有。",
    image: "https://readdy.ai/api/search-image?query=colorful%20entertainment%20stage%20with%20spotlights%20and%20microphones%2C%20energetic%20crowd%20silhouette%2C%20warm%20orange%20glow%20with%20deep%20blue%20background%2C%20vibrant%20show%20atmosphere&width=600&height=400&seq=sehu-cat-variety&orientation=landscape",
  },
  {
    key: "anime",
    name: "动漫",
    icon: "ri-sparkling-2-line",
    desc: "热血新番、经典长篇与治愈动画，二次元精彩汇聚。",
    image: "https://readdy.ai/api/search-image?query=stylized%20anime%20cityscape%20at%20sunset%20with%20glowing%20skyline%2C%20dramatic%20clouds%20and%20vivid%20orange%20and%20deep%20blue%20gradient%2C%20illustration%20aesthetic%20high%20detail&width=600&height=400&seq=sehu-cat-anime&orientation=landscape",
  },
];

export const regions = ["全部", "大陆", "港台", "欧美", "日韩", "其他"];
export const genres = [
  "全部",
  "剧情",
  "动作",
  "喜剧",
  "科幻",
  "悬疑",
  "犯罪",
  "爱情",
  "奇幻",
  "冒险",
  "历史",
  "动画",
];
export const years = ["全部", "2025", "2024", "2023", "2022", "2021"];

export const categoryNames: Record<string, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
  anime: "动漫",
};

export const movies: Movie[] = [
  {
    id: "shadow-chaser",
    title: "暗影追猎",
    category: "movie",
    genres: ["动作", "科幻"],
    region: "欧美",
    year: 2025,
    rating: 9.1,
    director: "詹姆斯·凯恩",
    actors: ["亚历克斯·里德", "玛丽亚·桑切斯", "卢卡斯·贝克"],
    synopsis:
      "近未来的霓虹都市中，一名独行赏金猎人被卷入跨国科技阴谋。为找回失落的记忆芯片，他必须穿越整座被企业武装掌控的城市，在追捕与反追捕之间揭开真相。",
    duration: "132分钟",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20sci-fi%20movie%20poster%2C%20lone%20hooded%20hunter%20in%20futuristic%20armor%20standing%20in%20neon%20city%20ruins%2C%20dramatic%20rim%20lighting%2C%20dark%20teal%20and%20orange%20color%20grading%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20banner%2C%20futuristic%20hunter%20silhouette%20over%20neon%20skyline%20at%20dusk%2C%20rain%20and%20mist%2C%20deep%20blue%20and%20orange%20lighting%2C%20epic%20sci-fi%20still%2C%20high%20detail&width=1600&height=900&seq=sehu-banner-01&orientation=landscape",
    featured: true,
    updatedAt: "2025-09-28",
  },
  {
    id: "neon-horizon",
    title: "霓虹地平线",
    category: "movie",
    genres: ["科幻", "冒险"],
    region: "欧美",
    year: 2024,
    rating: 8.7,
    director: "索菲亚·雷诺",
    actors: ["丹尼尔·科尔", "艾米·沃克"],
    synopsis:
      "一支深空探索队抵达宜居行星，却发现这里的时间流速与地球不同。面对逐渐崩解的母星信号，他们必须在陌生的地平线上做出抉择。",
    duration: "146分钟",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20astronaut%20looking%20at%20a%20glowing%20alien%20planet%20horizon%2C%20purple%20and%20orange%20nebula%20sky%2C%20dramatic%20scale%2C%20dark%20background%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-02&orientation=portrait",
    updatedAt: "2025-09-20",
  },
  {
    id: "silent-verdict",
    title: "沉默判决",
    category: "movie",
    genres: ["剧情", "悬疑"],
    region: "大陆",
    year: 2025,
    rating: 8.9,
    director: "陆铭",
    actors: ["周衍", "林静", "许知远"],
    synopsis:
      "一桩尘封十年的旧案重新开庭，辩护律师与检察官各自怀揣秘密。当证词层层剥开，沉默的真相究竟指向谁？",
    duration: "118分钟",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20legal%20thriller%20movie%20poster%2C%20lone%20figure%20silhouette%20in%20a%20dark%20courtroom%2C%20single%20beam%20of%20light%2C%20deep%20blue%20shadows%20with%20orange%20highlight%2C%20tense%20mood%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-03&orientation=portrait",
    updatedAt: "2025-09-25",
  },
  {
    id: "crimson-tide",
    title: "赤潮",
    category: "movie",
    genres: ["动作", "犯罪"],
    region: "港台",
    year: 2024,
    rating: 8.3,
    director: "陈国栋",
    actors: ["郑家豪", "梁诗敏", "黄国维"],
    synopsis:
      "码头夜色下，一宗走私交易引发连锁火并。卧底警探游走于黑白之间，越接近真相，越无法全身而退。",
    duration: "124分钟",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20action%20movie%20poster%2C%20night%20harbor%20with%20glowing%20lights%20and%20wet%20street%20reflections%2C%20lone%20figure%20in%20long%20coat%2C%20deep%20blue%20and%20red%20orange%20tones%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-04&orientation=portrait",
    updatedAt: "2025-08-30",
  },
  {
    id: "midnight-letter",
    title: "午夜来信",
    category: "movie",
    genres: ["爱情", "剧情"],
    region: "日韩",
    year: 2023,
    rating: 8.5,
    director: "小林澄",
    actors: ["佐藤美咲", "金智勋"],
    synopsis:
      "一封误寄的旧信让两个陌生人在雨夜的城市里相遇。他们约定只在午夜通信，却慢慢发现彼此早已在对方生命里留下痕迹。",
    duration: "109分钟",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20movie%20poster%2C%20couple%20sharing%20umbrella%20on%20rainy%20city%20street%20at%20night%2C%20warm%20orange%20street%20lamps%20against%20deep%20blue%20rain%2C%20soft%20bokeh%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-05&orientation=portrait",
    updatedAt: "2025-07-18",
  },
  {
    id: "iron-rain",
    title: "铁雨将至",
    category: "movie",
    genres: ["历史", "剧情"],
    region: "大陆",
    year: 2024,
    rating: 8.8,
    director: "白川",
    actors: ["张北望", "沈霆", "罗立"],
    synopsis:
      "风雨飘摇的年代，一支守军在孤城中坚守四十天。当补给耗尽、援军未至，他们用信念写下了最沉重的一页。",
    duration: "151分钟",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20war%20epic%20movie%20poster%2C%20lone%20soldier%20standing%20in%20smoke%20on%20a%20ruined%20battlefield%2C%20storm%20clouds%2C%20muted%20blue%20and%20orange%20fire%20glow%2C%20gritty%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-06&orientation=portrait",
    updatedAt: "2025-08-11",
  },
  {
    id: "star-wanderer",
    title: "星际流浪者",
    category: "movie",
    genres: ["科幻", "冒险"],
    region: "欧美",
    year: 2025,
    rating: 9.0,
    director: "奥利弗·格兰特",
    actors: ["伊森·布莱克", "娜塔莉·吴", "卡尔·门罗"],
    synopsis:
      "一艘世代飞船上，最后一代船员发现航线早已偏离。为寻找可栖居的新家园，他们不得不穿越从未被记录的星域。",
    duration: "139分钟",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20space%20odyssey%20movie%20poster%2C%20lone%20traveler%20silhouette%20before%20a%20giant%20glowing%20planet%2C%20swirling%20starfield%2C%20deep%20blue%20cosmos%20with%20orange%20sun%20flare%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20space%20banner%2C%20spaceship%20drifting%20past%20a%20glowing%20ringed%20planet%2C%20vast%20starfield%20nebula%2C%20deep%20blue%20and%20orange%20glow%2C%20epic%20scale%20film%20still%2C%20high%20detail&width=1600&height=900&seq=sehu-banner-02&orientation=landscape",
    featured: true,
    updatedAt: "2025-09-30",
  },
  {
    id: "lost-city-echo",
    title: "失城回响",
    category: "movie",
    genres: ["悬疑", "犯罪"],
    region: "大陆",
    year: 2023,
    rating: 8.2,
    director: "安宁",
    actors: ["傅远", "苏梨"],
    synopsis:
      "一座被遗弃的工业城市里，接连失踪的居民指向同一个声音。侦探循着回响深入废墟，也逐渐走近自己不愿面对的过去。",
    duration: "112分钟",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20thriller%20movie%20poster%2C%20detective%20with%20flashlight%20in%20abandoned%20industrial%20ruins%2C%20fog%20and%20dust%2C%20deep%20blue%20shadow%20with%20orange%20light%20beam%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-08&orientation=portrait",
    updatedAt: "2025-06-22",
  },
  {
    id: "laughter-club",
    title: "笑料俱乐部",
    category: "movie",
    genres: ["喜剧"],
    region: "大陆",
    year: 2024,
    rating: 7.9,
    director: "侯亮",
    actors: ["孟小飞", "唐甜", "赵大力"],
    synopsis:
      "一群混得不太如意的小人物合伙开了一间深夜喜剧俱乐部。为了活下去，他们决定用最笨的办法博满堂彩。",
    duration: "106分钟",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20comedy%20movie%20poster%2C%20retro%20stage%20with%20microphone%20and%20warm%20neon%20bulbs%2C%20playful%20orange%20and%20blue%20lighting%2C%20fun%20energetic%20mood%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-09&orientation=portrait",
    updatedAt: "2025-07-02",
  },
  {
    id: "dragon-vein",
    title: "龙脉",
    category: "movie",
    genres: ["奇幻", "冒险"],
    region: "港台",
    year: 2025,
    rating: 8.6,
    director: "程天佑",
    actors: ["关仲衡", "叶清", "洪嘉"],
    synopsis:
      "传说中沉睡千年的龙脉即将苏醒。一名年轻考古学者深入群山，在山河与古老秘术之间，守护即将失衡的世界。",
    duration: "128分钟",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20adventure%20movie%20poster%2C%20ancient%20mountain%20range%20with%20glowing%20dragon%20energy%20in%20the%20sky%2C%20lone%20traveler%20silhouette%2C%20deep%20blue%20mist%20with%20orange%20golden%20light%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20fantasy%20banner%2C%20misty%20ancient%20mountains%20with%20a%20giant%20glowing%20dragon%20coiling%20through%20clouds%2C%20deep%20blue%20sky%20with%20orange%20golden%20light%2C%20epic%20film%20still%2C%20high%20detail&width=1600&height=900&seq=sehu-banner-03&orientation=landscape",
    featured: true,
    updatedAt: "2025-10-01",
  },
  {
    id: "imperial-game",
    title: "帝京风云",
    category: "tv",
    genres: ["历史", "剧情"],
    region: "大陆",
    year: 2025,
    rating: 9.2,
    director: "高文远",
    actors: ["秦穆", "顾婉", "申屠明"],
    synopsis:
      "王朝末年，权臣当道。一位出身微末的年轻史官被卷入帝京的权力漩涡，在忠义与生存之间步步为营。",
    duration: "全46集",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=historical%20drama%20tv%20series%20poster%2C%20ancient%20imperial%20palace%20hall%20with%20golden%20throne%20and%20red%20pillars%2C%20lone%20figure%20in%20ornate%20robe%2C%20deep%20blue%20shadow%20with%20orange%20lantern%20glow%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-11&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20historical%20banner%2C%20grand%20ancient%20palace%20courtyard%20at%20dusk%20with%20lanterns%20glowing%2C%20dramatic%20clouds%2C%20deep%20blue%20and%20orange%20tones%2C%20epic%20period%20film%20still%2C%20high%20detail&width=1600&height=900&seq=sehu-banner-04&orientation=landscape",
    featured: true,
    updatedAt: "2025-09-29",
  },
  {
    id: "code-blue",
    title: "急诊迷城",
    category: "tv",
    genres: ["剧情"],
    region: "大陆",
    year: 2024,
    rating: 8.7,
    director: "何晴",
    actors: ["宋宁", "江澜", "方屿"],
    synopsis:
      "一座城市急诊科里的日与夜。年轻的住院医师在生死时速中成长，也在一次次抉择里读懂医者仁心。",
    duration: "全38集",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=medical%20drama%20tv%20series%20poster%2C%20hospital%20corridor%20with%20cool%20emergency%20lighting%2C%20doctor%20in%20scrubs%20silhouette%2C%20deep%20blue%20tones%20with%20orange%20emergency%20glow%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-12&orientation=portrait",
    updatedAt: "2025-08-16",
  },
  {
    id: "hidden-truth",
    title: "暗巷真凶",
    category: "tv",
    genres: ["犯罪", "悬疑"],
    region: "港台",
    year: 2025,
    rating: 8.9,
    director: "李泽楷",
    actors: ["麦子豪", "何静仪", "谭柏"],
    synopsis:
      "一名直觉敏锐的老刑警与一位数据分析师联手，追查一桩跨越二十年的连环悬案，真相藏在城市最不起眼的暗巷里。",
    duration: "全30集",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=crime%20mystery%20tv%20series%20poster%2C%20dark%20rainy%20alley%20at%20night%20with%20flickering%20neon%20signs%2C%20detective%20silhouette%2C%20deep%20blue%20shadow%20with%20orange%20reflection%2C%20tense%20mood%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-13&orientation=portrait",
    updatedAt: "2025-09-24",
  },
  {
    id: "seoul-nights",
    title: "首尔夜未眠",
    category: "tv",
    genres: ["爱情", "剧情"],
    region: "日韩",
    year: 2024,
    rating: 8.4,
    director: "朴俊昊",
    actors: ["李瑞妍", "姜道河"],
    synopsis:
      "两位在城市里追逐梦想的年轻人在深夜便利店相遇。他们约定只在凌晨倾诉心事，却在白天一次次错过彼此。",
    duration: "全24集",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20korean%20drama%20poster%2C%20young%20couple%20in%20a%20convenience%20store%20at%20night%2C%20warm%20orange%20lights%20against%20deep%20blue%20city%20bokeh%2C%20soft%20cinematic%20mood%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-14&orientation=portrait",
    updatedAt: "2025-07-27",
  },
  {
    id: "silicon-wars",
    title: "硅谷风云",
    category: "tv",
    genres: ["剧情"],
    region: "欧美",
    year: 2023,
    rating: 8.6,
    director: "马克·汉密尔顿",
    actors: ["彼得·诺兰", "艾拉·格林", "乔·班克斯"],
    synopsis:
      "一间车库里的初创公司一夜爆红，创始团队在资本、野心与友情之间艰难平衡。硅谷的每一次高光背后都有代价。",
    duration: "全32集",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20tech%20drama%20poster%2C%20stylish%20startup%20office%20with%20glass%20walls%20and%20glowing%20screens%20at%20night%2C%20deep%20blue%20tones%20with%20orange%20accent%20lighting%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-15&orientation=portrait",
    updatedAt: "2025-06-09",
  },
  {
    id: "phoenix-song",
    title: "凤鸣九霄",
    category: "tv",
    genres: ["历史", "奇幻"],
    region: "大陆",
    year: 2025,
    rating: 8.8,
    director: "白薇",
    actors: ["宁芷", "裴逸", "慕容安"],
    synopsis:
      "乱世之中，一位背负家族命运的少女觉醒凤凰血脉。她要在朝堂阴谋与江湖纷争中，找回属于自己的力量。",
    duration: "全42集",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20fantasy%20tv%20series%20poster%2C%20heroine%20in%20flowing%20ornate%20robe%20with%20glowing%20phoenix%20aura%2C%20deep%20blue%20night%20sky%20with%20orange%20golden%20light%2C%20dramatic%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-16&orientation=portrait",
    updatedAt: "2025-09-18",
  },
  {
    id: "home-fireworks",
    title: "烟火人家",
    category: "tv",
    genres: ["剧情"],
    region: "大陆",
    year: 2024,
    rating: 8.1,
    director: "陈思远",
    actors: ["刘惠兰", "张建国", "陈小雪"],
    synopsis:
      "老城区里的一家人，围绕着一间小饭馆展开三十年的悲欢。柴米油盐里，藏着最动人的亲情与和解。",
    duration: "全36集",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20family%20drama%20poster%2C%20cozy%20old%20town%20kitchen%20with%20steaming%20dishes%20and%20warm%20lamplight%2C%20deep%20blue%20evening%20window%20with%20orange%20glow%2C%20nostalgic%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-17&orientation=portrait",
    updatedAt: "2025-08-05",
  },
  {
    id: "sunshine-detective",
    title: "阳光侦探社",
    category: "tv",
    genres: ["犯罪", "喜剧"],
    region: "日韩",
    year: 2023,
    rating: 8.5,
    director: "田中凉",
    actors: ["高桥悠", "森川绫"],
    synopsis:
      "一间开在写字楼角落的迷你侦探社，接的都是些鸡毛蒜皮的小案子。可每一次看似搞笑的事件背后，都藏着生活的温柔。",
    duration: "全22集",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=quirky%20detective%20comedy%20poster%2C%20cozy%20little%20detective%20office%20with%20cluttered%20desk%20and%20magnifying%20glass%2C%20warm%20orange%20sunlight%20with%20deep%20blue%20shadows%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-18&orientation=portrait",
    updatedAt: "2025-06-15",
  },
  {
    id: "super-voice",
    title: "天籁之战",
    category: "variety",
    genres: ["音乐"],
    region: "大陆",
    year: 2025,
    rating: 8.6,
    director: "综艺制作组",
    actors: ["林声", "方雅", "陈牧"],
    synopsis:
      "顶级歌手与素人新声同台竞演，用一首首金曲点燃舞台。每一次改编，都是一场关于热爱的对话。",
    duration: "更新至第12期",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=music%20competition%20show%20poster%2C%20singer%20silhouette%20on%20a%20stage%20with%20dramatic%20spotlights%20and%20camera%20flashes%2C%20deep%20blue%20background%20with%20orange%20stage%20light%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-19&orientation=portrait",
    updatedAt: "2025-10-03",
  },
  {
    id: "kitchen-stars",
    title: "星厨驾到",
    category: "variety",
    genres: ["剧情"],
    region: "大陆",
    year: 2024,
    rating: 8.2,
    director: "综艺制作组",
    actors: ["周美厨", "陆小鲜"],
    synopsis:
      "明星嘉宾走进专业厨房，在限时挑战中比拼厨艺。烟火气十足的赛场上，藏着最真实的生活态度。",
    duration: "更新至第10期",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=gourmet%20cooking%20show%20poster%2C%20professional%20kitchen%20with%20flames%20and%20steam%2C%20chef%20plate%20in%20focus%2C%20warm%20orange%20lighting%20with%20deep%20blue%20shadows%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-20&orientation=portrait",
    updatedAt: "2025-07-14",
  },
  {
    id: "travel-together",
    title: "一路同行",
    category: "variety",
    genres: ["冒险"],
    region: "大陆",
    year: 2025,
    rating: 8.4,
    director: "综艺制作组",
    actors: ["行走团"],
    synopsis:
      "几位好友踏上横跨南北的自驾旅程。没有剧本，只有沿途的风景、意外的相遇和最真诚的陪伴。",
    duration: "更新至第14期",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=travel%20reality%20show%20poster%2C%20road%20trip%20van%20on%20a%20winding%20mountain%20road%20at%20golden%20hour%2C%20deep%20blue%20distant%20mountains%20with%20orange%20sunlight%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-21&orientation=portrait",
    updatedAt: "2025-09-21",
  },
  {
    id: "comedy-night",
    title: "爆笑之夜",
    category: "variety",
    genres: ["喜剧"],
    region: "大陆",
    year: 2024,
    rating: 7.8,
    director: "综艺制作组",
    actors: ["脱口秀群星"],
    synopsis:
      "每周一次的深夜脱口秀现场，来自各行各业的新人用幽默化解生活的难。笑声背后，是真实的共鸣。",
    duration: "更新至第16期",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=comedy%20talk%20show%20poster%2C%20dark%20club%20stage%20with%20neon%20signs%20and%20a%20single%20microphone%2C%20warm%20orange%20glow%20with%20deep%20blue%20background%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-22&orientation=portrait",
    updatedAt: "2025-07-30",
  },
  {
    id: "brain-king",
    title: "最强大脑",
    category: "variety",
    genres: ["悬疑"],
    region: "大陆",
    year: 2025,
    rating: 8.3,
    director: "综艺制作组",
    actors: ["脑力挑战团"],
    synopsis:
      "全国顶尖的脑力选手同台竞技，在记忆、推理与空间挑战中刷新极限，见证人类大脑的无限可能。",
    duration: "更新至第8期",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=competition%20show%20poster%2C%20abstract%20glowing%20geometric%20puzzle%20blueprint%20on%20a%20dark%20stage%2C%20deep%20blue%20with%20orange%20highlight%2C%20futuristic%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-23&orientation=portrait",
    updatedAt: "2025-09-12",
  },
  {
    id: "idol-stage",
    title: "星光舞台",
    category: "variety",
    genres: ["音乐"],
    region: "日韩",
    year: 2024,
    rating: 8.0,
    director: "综艺制作组",
    actors: ["偶像练习生"],
    synopsis:
      "怀揣舞台梦想的年轻人在聚光灯下接受考验，用汗水与热爱争夺最终出道的席位。",
    duration: "更新至第12期",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=idol%20audition%20show%20poster%2C%20glowing%20stage%20with%20dancers%20silhouettes%20and%20colorful%20spotlights%2C%20deep%20blue%20background%20with%20orange%20beams%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-24&orientation=portrait",
    updatedAt: "2025-08-22",
  },
  {
    id: "blade-of-dawn",
    title: "破晓之刃",
    category: "anime",
    genres: ["动画", "冒险"],
    region: "日韩",
    year: 2025,
    rating: 9.3,
    director: "宫野新",
    actors: ["主角配音：花井透", "配角配音：水野凛"],
    synopsis:
      "在妖魔横行的乱世，一位少年剑客继承家传之刃。为了守护黎明前最后的平静，他踏上斩妖之路。",
    duration: "更新至第24话",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20swordsman%20poster%2C%20young%20warrior%20holding%20a%20glowing%20blade%20at%20dawn%2C%20cherry%20blossoms%20and%20misty%20mountains%2C%20deep%20blue%20sky%20with%20orange%20sunrise%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-25&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20anime%20wide%20banner%2C%20young%20swordsman%20facing%20a%20vast%20misty%20mountain%20range%20at%20dawn%2C%20petals%20in%20the%20wind%2C%20deep%20blue%20and%20orange%20gradient%20sky%2C%20epic%20illustration%20high%20detail&width=1600&height=900&seq=sehu-banner-05&orientation=landscape",
    featured: true,
    updatedAt: "2025-10-04",
  },
  {
    id: "spirit-academy",
    title: "灵能学园",
    category: "anime",
    genres: ["动画", "奇幻"],
    region: "日韩",
    year: 2024,
    rating: 9.0,
    director: "佐伯遥",
    actors: ["主角配音：山田葵", "配角配音：石井悠"],
    synopsis:
      "一所培养灵能者的秘密学园里，资质平平的新生意外觉醒了古老力量。友情、成长与危机，在校园中交织。",
    duration: "更新至第36话",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20magic%20academy%20poster%2C%20student%20casting%20glowing%20spell%20runes%20in%20a%20grand%20hall%2C%20deep%20blue%20night%20with%20orange%20magic%20light%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-26&orientation=portrait",
    updatedAt: "2025-08-28",
  },
  {
    id: "mecha-frontier",
    title: "机甲边境",
    category: "anime",
    genres: ["动画", "科幻"],
    region: "大陆",
    year: 2025,
    rating: 8.7,
    director: "陈星野",
    actors: ["主角配音：江屿", "配角配音：苏澜"],
    synopsis:
      "边境星系战火再起，年轻的机甲驾驶员们驾驶着各自的爱机奔赴前线，在钢铁与信念间守护家园。",
    duration: "更新至第20话",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20mecha%20robot%20poster%2C%20giant%20humanoid%20robot%20standing%20in%20a%20futuristic%20city%20at%20dusk%2C%20glowing%20thrusters%2C%20deep%20blue%20with%20orange%20energy%20light%2C%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-27&orientation=portrait",
    updatedAt: "2025-09-26",
  },
  {
    id: "panda-heroes",
    title: "熊猫侠",
    category: "anime",
    genres: ["动画", "喜剧"],
    region: "大陆",
    year: 2024,
    rating: 8.5,
    director: "何晓",
    actors: ["主角配音：米团", "配角配音：竹哥"],
    synopsis:
      "一只爱吃竹子的小熊猫意外获得超能力，从此和伙伴们一起守护森林小镇，在爆笑日常中传递温暖。",
    duration: "更新至第52话",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=cute%20animated%20panda%20hero%20poster%2C%20cheerful%20cartoon%20panda%20in%20a%20cape%20flying%20over%20a%20green%20forest%20town%2C%20warm%20orange%20sunset%20with%20deep%20blue%20sky%2C%20playful%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-28&orientation=portrait",
    updatedAt: "2025-07-08",
  },
  {
    id: "moonlit-sword",
    title: "月下剑客",
    category: "anime",
    genres: ["动画", "奇幻"],
    region: "日韩",
    year: 2023,
    rating: 8.8,
    director: "黑川真",
    actors: ["主角配音：桐生一", "配角配音：白羽"],
    synopsis:
      "行走在江户夜色中的盲眼剑客，以听风辨位。为寻找失散的妹妹，他只身对抗盘踞黑夜的妖异势力。",
    duration: "全26话",
    quality: "HD",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20samurai%20poster%2C%20blind%20swordsman%20under%20a%20huge%20moon%20in%20a%20bamboo%20forest%2C%20deep%20blue%20night%20with%20orange%20lantern%20glow%2C%20cinematic%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-29&orientation=portrait",
    updatedAt: "2025-06-30",
  },
  {
    id: "cloud-kingdom",
    title: "云之王国",
    category: "anime",
    genres: ["动画", "奇幻"],
    region: "欧美",
    year: 2025,
    rating: 8.9,
    director: "艾米丽·卡特",
    actors: ["主角配音：莉莉·安", "配角配音：诺亚·文"],
    synopsis:
      "在漂浮于云端的奇幻王国，一位学徒被选中守护连接天空与陆地的古老航道。一场关于勇气与责任的冒险就此展开。",
    duration: "更新至第18话",
    quality: "4K",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20fantasy%20anime%20poster%2C%20floating%20sky%20islands%20with%20waterfalls%20and%20soaring%20creatures%2C%20deep%20blue%20clouds%20with%20orange%20sunlight%2C%20epic%20illustration%20high%20detail%20vertical%20composition&width=600&height=900&seq=sehu-cover-30&orientation=portrait",
    updatedAt: "2025-10-02",
  },
];